export default {
    MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM: 'MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM',
    MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_SUCCESS: 'MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_SUCCESS',
    MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_FAILED: 'MEALS_MEAL_REGISTRATION_CREATE_FOOD_ITEM_FAILED',
    MEALS_MEAL_REGISTRATION_SHOW: 'MEALS_MEAL_REGISTRATION_SHOW',
    MEALS_MEAL_REGISTRATION_EDIT: 'MEALS_MEAL_REGISTRATION_EDIT',
    MEALS_MEAL_REGISTRATION_VIEW: 'MEALS_MEAL_REGISTRATION_VIEW',
    MEALS_MEAL_REGISTRATION_HIDE: 'MEALS_MEAL_REGISTRATION_HIDE',
    MEALS_MEAL_REGISTRATION_CANCEL: 'MEALS_MEAL_REGISTRATION_CANCEL',
    MEALS_MEAL_REGISTRATION_SHOW_FOOD_SELECTION: 'MEALS_MEAL_REGISTRATION_SHOW_FOOD_SELECTION',
    MEALS_MEAL_REGISTRATION_HIDE_FOOD_SELECTION: 'MEALS_MEAL_REGISTRATION_HIDE_FOOD_SELECTION',
    MEALS_MEAL_REGISTRATION_FOOD_ITEM_SEARCH: 'MEALS_MEAL_REGISTRATION_FOOD_ITEM_SEARCH',
    MEALS_MEAL_REGISTRATION_FOOD_ITEM_WRITE_SEARCH: 'MEALS_MEAL_REGISTRATION_FOOD_ITEM_WRITE_SEARCH',
};
